export const showError = (message) => async (dispatch) => {
    dispatch({
        type: "error",
        payload: message
    });
}